import { Global } from '@emotion/react';
import { Inter } from 'next/font/google';

// NOTE: Next 16+ requires next/font to be a const within the file it is used - not imported
const inter = Inter({
  subsets: ['latin'],
  adjustFontFallback: false,
  fallback: ['open-sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
});

export const GlobalStyles = () => {
  return (
    <Global
      styles={{
        ':root': {
          '--side-font-family': inter.style.fontFamily,
        },
        // Disable native pinch/double-tap zoom app-wide so it can't compete with the document
        // viewer's own zoom (CORE-16307). `pan-x pan-y` keeps one-finger scrolling and covers
        // Android (Chrome/Firefox). iOS doesn't reliably honor touch-action for pinch, so it's
        // handled separately by useDisableNativePinchZoom. The document stays zoomable via RZPP.
        'html, body': {
          touchAction: 'pan-x pan-y',
        },
        // Hide the zendesk unread messages indicator, since we build our own indicator in the side nav
        'iframe[title="Number of unread messages"]': {
          display: 'none !important',
        },
        // Columns management popup is portaled outside the DataGrid; search icon needs left padding
        '.MuiDataGrid-columnsManagementSearchInput .MuiInputAdornment-positionStart':
          {
            paddingLeft: 8,
            marginRight: 0,
          },
        '.MuiDataGrid-columnsManagementSearchInput .MuiInputAdornment-positionEnd':
          {
            paddingRight: 8,
          },
      }}
    />
  );
};
